const CONSENTS = "CONSENTS";
const DRAFTS = "DRAFTS";

const consentsSections = {
  CONSENTS,
  DRAFTS
};

export default consentsSections;
